.multiSelectRoot {
  position: relative;
}

.multiSelectDropdown {
  background-color: var(--mantine-color-gray-0);
  border-style: solid;
  border-color: var(--mantine-color-gray-9);
}

.multiSelectPill {
  background-color: white;
  border: 1px solid var(--mantine-color-gray-4);
  text-overflow: ellipsis;
  max-width: 230px;
  border-radius: 4px;
}

.multiSelectPill svg {
  color: var(--mantine-color-gray-4);
}

.multiSelectPillsList {
  z-index: 1;
  width: 100%;
  padding: 0;
}

.multiSelectInput {
  font-family: "Work Sans";
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 8px 8px 12px;
  min-height: 42px;
}

.multiSelectLabel {
  position: absolute;
  pointer-events: none;
  font-size: var(--mantine-font-size-xs);
  margin-left: var(--mantine-spacing-sm);
  padding-left: calc(var(--mantine-spacing-xs) / 2);
  padding-right: calc(var(--mantine-spacing-xs) / 2);
  background-color: white;
  top: -10px;
  z-index: 1;
}

.multiSelectRequired {
  color: #f30505;
}
